import { motion } from "framer-motion";
import { useState, useEffect, forwardRef } from "react";
import { Parallax } from "react-scroll-parallax";
import { FiDownload, FiFileText } from "react-icons/fi";
import Resume from "../files/Rammir_CV.pdf";

const Hero = forwardRef(({ scrollToSection, projectsRef }, ref) => {
  const [textIndex, setTextIndex] = useState(0);
  const [isTypingComplete, setIsTypingComplete] = useState(false);
  const [showFollowUp, setShowFollowUp] = useState(false);
  const [showButtons, setShowButtons] = useState(false);

  const greetingText = "Hi, I'm Rammir";
  const followUpText =
    "Get started by viewing my skillset and completed projects.";

  useEffect(() => {
    if (textIndex < greetingText.length) {
      const timeout = setTimeout(() => {
        setTextIndex((prev) => prev + 1);
      }, 100);
      return () => clearTimeout(timeout);
    } else {
      setIsTypingComplete(true);
      setTimeout(() => setShowFollowUp(true), 300); // Delay before follow-up shows
    }
  }, [textIndex]);

  useEffect(() => {
    if (showFollowUp) {
      const timeout = setTimeout(() => {
        setShowButtons(true); // Delay before buttons appear after follow-up
      }, 700);
      return () => clearTimeout(timeout);
    }
  }, [showFollowUp]);

  return (
    <section
      id="hero"
      ref={ref}
      className="bg-transparent text-white min-h-screen snap-start flex items-center relative overflow-hidden"
    >
      {/* Main Content */}
      <div className="container mx-auto text-center z-10">
        <Parallax y={[-20, 20]} tagOuter="figure">
          {/* Typewriter effect for the main greeting */}
          <motion.h1
            className="font-pixelTitle text-4xl sm:text-6xl font-extrabold"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
          >
            {greetingText.slice(0, textIndex)}
          </motion.h1>

          {/* Follow-up message */}
          {showFollowUp && (
            <motion.p
              className="font-pixelBody mt-4 text-xl text-gray-400"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
            >
              {followUpText}
            </motion.p>
          )}

          {/* Buttons */}
          {showButtons && (
            <motion.div
              className="mt-6 flex flex-col sm:flex-row justify-center items-center gap-4"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5, ease: "easeOut" }}
            >
              <motion.button
                className="font-pixelAccent px-6 py-2 bg-green text-black flex items-center justify-center gap-2 rounded-lg hover:bg-opacity-80 transition-all duration-100"
                whileHover={{ scale: 1.05 }}
                onClick={() => scrollToSection(projectsRef)}
              >
                <FiFileText className="text-xl" />
                View My Projects
              </motion.button>

              <motion.a
                href={Resume}
                download
                className="font-pixelAccent px-6 py-2 bg-green text-black flex items-center justify-center gap-2 rounded-lg hover:bg-opacity-80 transition-all duration-100"
                whileHover={{ scale: 1.05 }}
              >
                <FiDownload className="text-xl" />
                Download Resume
              </motion.a>
            </motion.div>
          )}
        </Parallax>
      </div>
    </section>
  );
});

export default Hero;
